import script from "./SupportChatView.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportChatView.vue?vue&type=script&setup=true&lang=js"

import "./SupportChatView.vue?vue&type=style&index=0&id=e15ba0d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e15ba0d8"]])

export default __exports__